import { getCurrentConference, getJitsiRoom } from '../conference';
import {
    setAudioMuted,
    setVideoMuted,
} from '../media';

import {
    TRACK_ADDED,
    TRACK_CREATE_CANCELED,
    TRACK_CREATE_ERROR,
    TRACK_NO_DATA_FROM_SOURCE,
    TRACK_PARTICIPANT_UPDATE,
    TRACK_REMOVED,
    TRACK_STOPPED,
    TRACK_UPDATED,
    TRACK_WILL_CREATE
} from './actionTypes';


export function trackAdded(track) {
    return {
        type: TRACK_ADDED,
        track
    };
}

export function trackRemoved(track) {
    return {
        type: TRACK_REMOVED,
        track
    };
}


export function trackMutedChanged(track) {
    return {
        type: TRACK_UPDATED,
        track: {
            track,
            muted: track.isMuted()
        }
    };
}

export function noDataFromSource( track ) {
    return {
        type: TRACK_NO_DATA_FROM_SOURCE,
        track
    };
}

export function replaceLocalTrack(oldTrack, newTrack, conference) {
    return async (dispatch, getState) => {
        try {
            const joined = getCurrentConference(getState());
            
            if (joined) {   
                await APP.mateManagement.replaceConferenceTrack(oldTrack, newTrack);                
            }

            return dispatch(replaceStoredTracks(oldTrack, newTrack));
        } catch (er) {
            console.log(er)
        }
        
    };
}

function replaceStoredTracks(oldTrack, newTrack) {
    return dispatch => {
        const disposePromise
              = oldTrack
                  ? dispatch(disposeAndRemoveTracks([ oldTrack ]))
                  : Promise.resolve();
        
        return disposePromise
            .then(() => {
                if (newTrack) {
                    const setMuted = newTrack.isVideoTrack() ? setVideoMuted : setAudioMuted;
                    const isMuted = newTrack.isMuted();

                    // console.log(`test Replace ${newTrack.getType()} track - ${isMuted ? 'muted' : 'unmuted'}`);

                    return dispatch(setMuted(isMuted));
                }
            })
            .then(() => {
                if (newTrack) {      
                    return dispatch(_addTracks([ newTrack ]));
                }
            });
    };
}

export function disposeAndRemoveTracks(tracks) {
    return dispatch => APP.mateManagement.disposeTracks(tracks)
        .then(() => {
            Promise.all(tracks.map(t => dispatch(trackRemoved(t))));
        });    
}

export function trackNoDataFromSourceNotificationInfoChanged(track, noDataFromSourceNotificationInfo) {
    return {
        type: TRACK_UPDATED,
        track: {
            track,
            noDataFromSourceNotificationInfo
        }
    };
}

export function trackStopped(track) {
    return {
        type: TRACK_STOPPED,
        track: {
            track
        }
    }
}


export function trackVideoStarted( track ) {
    return {
        type: TRACK_UPDATED,
        track: {
            track,
            videoStarted: true
        }
    };
}

export function trackVideoTypeChanged(track, videoType) {
    return {
        type: TRACK_UPDATED,
        track: {
            track,
            videoType
        }
    };
}

// export function trackMemberId(trackId, userId) {
//     console.log(trackId, userId)
//     return {
//         type: TRACK_PARTICIPANT_UPDATE,
//         track: {
//             trackId,
//             userId
//         }
//     };
// }

function _addTracks(tracks) {
    return () => Promise.all(tracks.map(t => {
        APP.mateManagement.trackAdded(t);
    }));
}

function _cancelGUMProcesses(getState) {
    const logError
        = error =>
            logger.error('gumProcess.cancel failed', JSON.stringify(error));

    return Promise.all(
        getState()['features/base/tracks']
            .filter(t => t.local)
            .map(({ gumProcess }) =>
                gumProcess && gumProcess.cancel().catch(logError)));
}

export function trackWillCreate(params) {
    return {
        type: TRACK_WILL_CREATE,
        track: params
    }
}


export function onCreateLocalTracksRejected({ gum }, device) {
    return dispatch => {
        if (gum) {
            const { error } = gum;

            if (error) {
                dispatch({
                    type: TRACK_CREATE_ERROR,
                    permissionDenied: error.name === 'SecurityError',
                    trackType: device
                });
            }
        }
    };
}

export function trackCreateCanceled(mediaType) {
    return {
        type: TRACK_CREATE_CANCELED,
        trackType: mediaType
    };
}
export function showNoDataFromSourceVideoError(track) {
    return (dispatch, getState) => {
        let notificationInfo;

        if (!track) {
            return;
        }

        if (track.isReceivingData) {
            notificationInfo = undefined;
        } else {
            const notificationAction = showErrorNotification({
                descriptionKey: 'dialog.cameraNotSendingData',
                titleKey: 'dialog.cameraNotSendingDataTitle'
            });

            dispatch(notificationAction);
            notificationInfo = {
                uid: notificationAction.uid
            };
        }
        dispatch(trackNoDataFromSourceNotificationInfoChanged(track, notificationInfo));
    };
}
